var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0475,
    cy: 12.6431,
    r: 12.2193,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1936 6.00632C12.4624 5.17888 13.6331 5.17888 13.9019 6.00633L14.9205 9.14124C15.0407 9.51129 15.3856 9.76183 15.7747 9.76183L19.0709 9.76183C19.9409 9.76183 20.3027 10.8751 19.5988 11.3865L16.9321 13.324C16.6173 13.5527 16.4856 13.9581 16.6058 14.3281L17.6244 17.4631C17.8933 18.2905 16.9462 18.9786 16.2424 18.4672L13.5757 16.5297C13.2609 16.301 12.8346 16.301 12.5199 16.5297L9.85313 18.4672C9.14927 18.9786 8.20223 18.2905 8.47108 17.4631L9.48967 14.3281C9.60991 13.9581 9.47819 13.5527 9.16341 13.324L6.49669 11.3865C5.79283 10.8751 6.15457 9.76183 7.02459 9.76183L10.3208 9.76183C10.7099 9.76183 11.0548 9.51129 11.175 9.14124L12.1936 6.00632Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleStar);
export default __webpack_public_path__ + "static/media/circleStar.325e1f0fcccf07cc47d27cb54cbe0416.svg";
export { ForwardRef as ReactComponent };